import { createResource, createSignal } from 'solid-js';
import { useApi, isOk } from '../api';
import type { BotLicenseSlotDto } from '../api';
import { useActiveBot } from '../state/activeBot';

const [revision, setRevision] = createSignal(0);

export function refreshBotLicenses() { setRevision(r => r + 1); }

export function useBotLicense(licenseType: string) {
    const api = useApi();
    const { botId } = useActiveBot();
    const [slots] = createResource(
        () => ({ botId: botId(), revision: revision() }),
        async ({ botId: id }): Promise<BotLicenseSlotDto[] | null> => {
            if (!id) return null;
            const res = await api.botLicense.forBot(id);
            return isOk(res.data) ? res.data.value.licenses : null;
        });

    const slot = () => slots()?.find(s => s.licenseType === licenseType) ?? null;
    // Grace still licenses the bot; only an ended assignment does not.
    const licensed = () => {
        const state = slot()?.assignment?.state;
        return state === 'Active' || state === 'Grace';
    };
    return { slot, licensed, loaded: () => slots() !== undefined };
}
